import ScheduleSummary from './ScheduleSummary';

export default ScheduleSummary;
